import { render } from "./First_level.vue?vue&type=template&id=1599f89e&scoped=true"
import script from "./First_level.vue?vue&type=script&lang=js"
export * from "./First_level.vue?vue&type=script&lang=js"

import "./First_level.vue?vue&type=style&index=0&id=1599f89e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1599f89e"]])

export default __exports__